
import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');

  const handleNewsletterSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;

    setIsSubmitting(true);
    setSubmitStatus('');

    try {
      const formData = new FormData();
      formData.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d4td5qq2t66nrlpqes40', {
        method: 'POST',
        body: new URLSearchParams(formData as any)
      });

      if (response.ok) {
        setSubmitStatus('Successfully subscribed!');
        setEmail('');
      } else {
        setSubmitStatus('Failed to subscribe. Please try again.');
      }
    } catch (error) {
      setSubmitStatus('An error occurred. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#0A1628] text-white relative overflow-hidden rounded-t-3xl">
      {/* Background Watermark */}
      <div className="absolute inset-0 flex items-center justify-center opacity-5">
        <span className="text-9xl font-bold tracking-wider">ELTROM</span>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
          {/* Brand Column */}
          <div className="md:col-span-1">
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="https://public.readdy.ai/ai/img_res/ffceab47-7a7e-469f-b5af-3ab5e479fce7.png" 
                alt="ELTROM S.R.L." 
                className="h-8 w-auto"
              />
              <span className="text-2xl font-bold">ELTROM</span>
            </div>
            <p className="text-[#8A9BB0] text-lg font-medium">Secure. Private. Fast.</p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-6">Quick Links</h3>
            <div className="space-y-4">
              {[
                { name: 'Home', id: 'home' },
                { name: 'VPN', id: 'vpn' },
                { name: 'Features', id: 'features' },
                { name: 'About', id: 'about' },
                { name: 'Contact', id: 'contact' }
              ].map((link) => (
                <button
                  key={link.id}
                  onClick={() => scrollToSection(link.id)}
                  className="block text-[#8A9BB0] hover:text-[#00D9FF] transition-colors duration-200 cursor-pointer"
                >
                  {link.name}
                </button>
              ))}
            </div>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-white font-semibold mb-6">Support</h3>
            <div className="space-y-4">
              <button 
                onClick={() => scrollToSection('support')}
                className="block text-[#8A9BB0] hover:text-[#00D9FF] transition-colors duration-200 cursor-pointer"
              >
                Help Center
              </button>
              <button 
                onClick={() => scrollToSection('support')}
                className="block text-[#8A9BB0] hover:text-[#00D9FF] transition-colors duration-200 cursor-pointer"
              >
                Documentation
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="block text-[#8A9BB0] hover:text-[#00D9FF] transition-colors duration-200 cursor-pointer"
              >
                Contact Support
              </button>
            </div>
          </div>

          {/* Newsletter */}
          <div>
            <h3 className="text-white font-semibold mb-6">Stay Updated</h3>
            <p className="text-[#8A9BB0] mb-4">Get security tips and updates</p>
            <form onSubmit={handleNewsletterSubmit} data-readdy-form className="relative">
              <div className="flex">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  className="flex-1 bg-[#1A2847] border border-[#2A3B52] text-white placeholder-[#8A9BB0] px-4 py-3 rounded-l-full focus:outline-none focus:border-[#00D9FF] transition-colors duration-200"
                  required
                  disabled={isSubmitting}
                />
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="bg-[#00D9FF] text-white px-6 py-3 rounded-r-full hover:bg-[#00B8E6] transition-colors duration-200 disabled:opacity-50 cursor-pointer"
                >
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
              {submitStatus && (
                <p className={`mt-2 text-sm ${submitStatus.includes('Successfully') ? 'text-green-400' : 'text-red-400'}`}>
                  {submitStatus}
                </p>
              )}
            </form>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#2A3B52] pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-[#8A9BB0] text-sm">
              © 2025 ELTROM S.R.L. All rights reserved.
            </p>
            <a 
              href="https://readdy.ai/?origin=logo" 
              className="text-[#8A9BB0] hover:text-[#00D9FF] text-sm transition-colors duration-200 mt-4 md:mt-0"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
